<template>
  <ul class="card-contact">
    <li
      v-for="(contact, index) in contacts"
      :key="`card-contact-field-${index}`"
      class="card-contact__field"
    >
      <div class="card-contact__details_wrapper">
        <HdIcon :src="getContactIcon(contact)" :width="32" :height="32" />
        <div class="card-contact__details">
          <h4>
            {{ getContactFullName(contact) }}
          </h4>
          <address>
            <a class="card-contact__link" :href="`mailto:${contact.email}`">{{ contact.email }}</a>
            <a class="card-contact__link" :href="`tel:${contact.phone}`">{{ contact.phone }}</a>
          </address>
        </div>
      </div>
      <div class="card-contact__role">
        {{ getContactRole(contact) }}
        <div v-if="contact.my_homeday_access" class="card-contact__myhomeday">
          {{ $t('DASHBOARD.CARD.EXPANDED.CONTACT.MY_HOMEDAY') }}
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { HdIcon } from 'homeday-blocks';
import { key24Px as key, ownerOccupier } from 'homeday-assets';

export default {
  name: 'CardContact',
  components: { HdIcon },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icons() {
      return {
        key,
        ownerOccupier,
      };
    },
    contacts() {
      return this.deal.contacts;
    },
  },
  methods: {
    getContactIcon(contact) {
      return contact.role === 'owner' ? this.icons.key : this.icons.ownerOccupier;
    },
    getContactFullName(contact) {
      return [contact.salutation, contact.first_name, contact.last_name].join(' ');
    },
    getContactRole(contact) {
      const baseTranslationPath = 'DASHBOARD.CARD.EXPANDED.CONTACT.ROLE';
      const role = contact?.role?.toUpperCase();
      const gender = contact?.gender?.toUpperCase() ?? 'MALE';

      return this.$te(`${baseTranslationPath}.${role}_${gender}`)
        ? this.$t(`${baseTranslationPath}.${role}_${gender}`)
        : this.$t(`${baseTranslationPath}.${role}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-contact {
  &__field {
    @include font('DS-80');
    display: flex;
    flex-wrap: wrap;
    gap: $sp-s;
    justify-content: space-between;

    &:not(:last-child) {
      margin-bottom: $sp-m;
    }

    @include for('desktop') {
      gap: $sp-m;
    }

    svg {
      border-radius: 50%;
      box-shadow: 0 0 12px rgba(26, 27, 60, 0.16);
      min-height: $sp-l;
      min-width: $sp-l;
      padding: $sp-xs + $sp-xxs;
    }
  }

  &__details_wrapper {
    display: flex;
    gap: $sp-s;
  }

  &__role {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    text-align: right;
    max-width: 80px;

    @include for('desktop') {
      @include font('DS-100');
      max-width: unset;
    }
  }

  &__myhomeday {
    background-color: getShade($secondary-color, 120);
    border-radius: $sp-s;
    color: $primary-bg;
    margin-top: $sp-xs;
    padding: $sp-xxs $sp-s;
  }

  &__details {
    max-width: 196px;

    h4 {
      font-weight: 600;
      margin-bottom: $sp-xs;

      @include for('desktop') {
        @include font('DS-200');
      }
    }

    @include for('desktop') {
      max-width: unset;
    }
  }

  address {
    display: flex;
    flex-direction: column;

    @include for('desktop') {
      @include font('DS-100');
    }
  }

  &__link {
    color: getShade($secondary-color, 120);
    margin-bottom: $sp-xs + $sp-xxs;
    text-decoration: none;
  }
}
</style>
